import { toast } from 'react-toastify'
import moment from 'moment';
import Immutable from 'immutable'

import { createAxiosInstance, getModificaciones, attachFilesToEntity } from '../utils/helpers'
import { API_URL } from '.'
import * as types from './types'
import history from '../utils/history'
import { displayMessages, uploadFiles } from './common'


export function getSolicitud(id) {
	const axios = createAxiosInstance()
	return (dispatch) => {
		const fn0 = () => axios.get(`${API_URL}/solicitudes/hoteles/${id}`)
		Promise.all([fn0()])
		.then(res => {
			const solicitud = res[0].data.solicitud
			const aprobadores = res[0].data.aprobadores
			dispatch({ type: types.OBTENER_SOLICITUD_HOTELES, payload: { solicitud, aprobadores } })
		})
		.catch(err => {
			console.log(err)
			displayMessages(dispatch, err)
		})
	}
}


export function displayModalAddCotizacion(show, title, mode, index=null) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES, payload: { show, title, mode, index } })
		} else {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES, payload: { show } })
		}
	}
}


export function displayModalAddReservacion(show, title, index=null) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_RESERVACION, payload: { show, title, index } })
		} else {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_RESERVACION, payload: { show } })
		}
	}
}


export function displayModalAddAsistencia(show, title, index=null) {
	return (dispatch) => {
		if (show) {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_ASISTENCIA, payload: { show, title, index } })
		} else {
			dispatch({ type: types.MOSTRAR_MODAL_ADICIONAR_ASISTENCIA, payload: { show } })
		}
	}
}


export function removeCotizacion() {
	return (dispatch) => {
		dispatch({ type: types.REMOVER_COTIZACION_HOTELES })
	}
}




export function updateInputs(path, value, id = null, immutable = true) {
	return (dispatch) => {
        if(path === 'comentario.texto' || path.includes('huespedes') || path.includes('ciudad') || path === 'modalAddCotizacion.data.descripcion'){
            const regex = /[!@#$%^&*()_+\[\]{}|;':",.<>?´áéíóúÁÉÍÓÚ¡]/g;
            value = value.replace(regex, "").toUpperCase();
        }


        const fn0 = (d) => d({ type: types.MODIFICAR_INPUTS_SOLICITUD_HOTELES1, payload: { path, value, immutable } })
		fn0(dispatch)


        let entity
		const attribute = path.split('.').slice(-1)[0];
        switch (attribute) {
			case 'descripcion':
			case 'cotizado':
                entity = 'Cotizacione'
                break;
            default:
		}
        if (entity) {
            const fn1 = (d) => d({ type: types.ADICIONAR_MODIFICACION_SOLICITUD_HOTELES, payload: { id, entity, attribute, value, action: 'edit' } })
            fn1(dispatch)
		}

	}
}

export function addHuesped(payload) {
	return (dispatch, getState) => {
		const path = payload.path.split('.')[0]
        const solicitud = getState().solicitudhoteles.get(path).toJS();
        const huespedes = solicitud.hotel.huespedes;
		if (huespedes.filter(x => x.id=== payload.value.id).length !== 0) {
			toast.warn(`La persona ${payload.value.fullname} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
		} else {
            const solicitud = getState().solicitudhoteles.get(path).toJS();
            const huespedes = solicitud.hotel.huespedes;
			let huesped = getState().solicitudhoteles.getIn(payload.path.split('.')).toJS()
			huesped = {...huesped, ...payload.value}
			huesped.correo = huesped.email
			huesped.cedula = huesped.username
			payload.value = huesped
			dispatch({ type: types.MODIFICAR_INPUTS_SOLICITUD_HOTELES1, payload })
		}
	}
}





export function addFile(path) {
	return (dispatch, getState) => {
		const data = getState().common.getIn(['modalAddFile', 'data'])
		const errors = []
		if (!data.get('file')) errors.push('No adicionó ningun archivo')
		if (!data.get('clasificacion')) errors.push('No se seleccionó ninguna clasificación')
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn1 = (d) => d({ type: types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES, payload: {path, data} })
			const fn2 = (d) => d({ type: types.OCULTAR_MODAL_AGREGAR_ARCHIVO })
			fn1(dispatch)
			fn2(dispatch)
		}
	}
}








export function addOrEditCotizacion() {
	return (dispatch, getState) => {

		const cotizacion = getState().solicitudhoteles.getIn(['modalAddCotizacion', 'data'])

		const errors = validateCotizacion(cotizacion)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const data = getState()
				.solicitudhoteles
				.getIn(['modalAddCotizacion', 'data'])
				.set('fecha_entrega', moment().format('YYYY-MM-DD'))
				.set('estado', 4)

			const fn0 = (d) => d({ type: types.ADICIONAR_COTIZACION_HOTELES, payload: { data } })
			const fn1 = (d) => d({ type: types.MOSTRAR_MODAL_ADICIONAR_COTIZACION_HOTELES, payload: { show: false } })


			fn0(dispatch)
			fn1(dispatch)

		}

	}
}





export function editHuesped(index) {

	return (dispatch, getState) => {

		const data = getState().solicitudhoteles.getIn(['modalAddReservacion', 'data'])

		const errors = validateReservacion(data)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {
			const fn0 = (d) => d({ type: types.MODIFICAR_RESERVACION, payload: { index, data } })
			const fn1 = (d) => d({ type: types.MOSTRAR_MODAL_ADICIONAR_RESERVACION, payload: { show: false } })
			fn0(dispatch)
			fn1(dispatch)
		}
	}
}


export function updateSolicitudHoteles() {

	const axios = createAxiosInstance()

	return (dispatch, getState) => {
		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_HOTELES, payload: false })
		fn0(dispatch)

		const solicitud = getState().solicitudhoteles.get('id')
		const solicitudNew = getState().solicitudhoteles.get('solicitud')
		const solicitudOld = getState().solicitudhoteles.get('unchaged')

		let files = []

		files = attachFilesToEntity('Cotizacione', solicitudNew.get('cotizaciones'))

		const errors = validateSolicitud(solicitudNew)


		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = getModificaciones(solicitudNew, solicitudOld, 'Solicitude', switchDocumento)

			axios.put(`${API_URL}/solicitudes/hoteles/${solicitud}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_HOTELES, payload: { solicitud, aprobadores } })
				const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas')
				const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn2, fn3, fn4]))
			})
			.catch(err => {
				displayMessages(dispatch, err)
				fn1(dispatch)
			})


		}
	}
}


export function seleccionarAprobacion(indexAprobador, indexAprobacion) {
	return (dispatch) => {
		dispatch({ type: types.SELECCIONAR_APROBACION_SOLICITUD_HOTELES, payload: {indexAprobador, indexAprobacion} })
	}
}

export function registerApprovalResult(aprobaciones, result) {

	const ip = require('ip');
	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().solicitudhoteles.get('solicitud')

		const errors = result > 0 ? validateAprobacion(aprobaciones, result) : validateAprobacion(aprobaciones.first().get('observaciones'), result)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = []

			aprobaciones.map(a => {
				modificaciones.push({
					id: a.get('id'),
					entity: 'Aprobacione',
					value: { estado: result > 0 ? (a.get('estado') == 1 ? 0 : a.get('estado')) : 0, ip: ip.address(), observaciones: aprobaciones.first().get('observaciones') },
					action: 'edit'
				})
			})


			const disCencos = solicitud.getIn(['hotel', 'cencos'])

			disCencos.map(c => {
				if (c.getIn(['pivot', 'rubro_id'])) {
					modificaciones.push({
						id: c.getIn(['pivot', 'id']),
						entity: 'DisCencoHotel',
						value: { rubro_id: c.getIn(['pivot', 'rubro_id']) },
						action: 'edit'
					})
				}
			})

			axios.put(`${API_URL}/solicitudes/hoteles/${solicitud.get('id')}`, modificaciones)
				.then(res => {
					const solicitud = res.data.solicitud
					const aprobadores = res.data.aprobadores
					const fn0 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_HOTELES, payload: { solicitud, aprobadores } })
					fn0(dispatch)

					displayMessages(dispatch, { success: 'La solicitud ha sido guardada exitosamente' })

				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
				})

		}
	}
}



export function registerReservaciones() {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().solicitudhoteles.get('solicitud')

		const modificaciones = []
		let files

		let reservaciones = Immutable.List()

		const huespedes = solicitud.getIn(['hotel', 'huespedes'])

		const errors = validateReservaciones(huespedes)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			huespedes.map(p => {

				reservaciones = reservaciones.push(p.get('reservacion'))

				p = p.deleteIn(['reservacion', 'adjunto'])

				modificaciones.push({
					id: p.getIn(['reservacion', 'id']),
					entity: 'Reservacion',
					value: p.get('reservacion'),
					action: 'edit'
				})

				p.getIn(['reservacion', 'rutas']).map(i => {
					modificaciones.push({
						id: i.get('id'),
						entity: 'RutasReservacion',
						value: i,
						action: 'edit'
					})
				})

			})

			files = attachFilesToEntity('Reservacion', reservaciones)

			axios.put(`${API_URL}/solicitudes/hoteles/${solicitud.get('id')}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn2 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_HOTELES, payload: { solicitud, aprobadores } })
				const fn3 = () => history.push(window.FOLDER + '/solicitudes/abiertas')
				const fn4 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				dispatch(uploadFiles(`/files/${res.data.solicitud.id}`, files, [fn2, fn3, fn4]))
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
			})


		}

	}
}


export function registerReservacionesExpirados() {

	const axios = createAxiosInstance()
	return (dispatch, getState) => {

		const solicitud = getState().solicitudhoteles.get('solicitud')

		let rutas = Immutable.List()

		//const hoy = new Date(2020, 11, 15)
		const hoy = new Date()


		solicitud.getIn(['hotel', 'huespedes']).map(p => {
			p.getIn(['reservacion', 'rutas']).filter(i => moment(i.get('fecha_salida')) < moment(hoy)).map(x => {
				rutas = rutas.push(x.set('numero_reservacion', p.getIn(['reservacion', 'numero_reservacion'])))
			})
		})

		const errors = validateReservacionesExpirados(rutas)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = []

			rutas.map(i => {
				modificaciones.push({
					id: i.get('id'),
					entity: 'RutasReservacion',
					value: { cumplido: i.get('cumplido'), observaciones: i.get('observaciones') },
					action: 'edit'
				})
			})

			axios.put(`${API_URL}/solicitudes/hoteles/${solicitud.get('id')}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn0 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_HOTELES, payload: { solicitud, aprobadores } })
				const fn1 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				fn0(dispatch)
				fn1()
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
			})

		}


	}
}


export function registerCancelacion() {

	const axios = createAxiosInstance()

	return (dispatch, getState) => {

		//const solicitud = getState().solicitudhoteles.get('solicitud').set('estado', 0)
		const solicitud = getState().solicitudhoteles.get('solicitud')

		const errors = validateSolicitud(solicitud, {cancelar: true})

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = []

			modificaciones.push({
				id: solicitud.get('id'),
				entity: 'Solicitude',
				value: { motivo_cancelacion: solicitud.get('motivo_cancelacion'), fecha_cancelacion: moment().format('YYYY-MM-DD') },
				action: 'edit'
			})

			axios.put(`${API_URL}/solicitudes/hoteles/${solicitud.get('id')}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn0 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_HOTELES, payload: { solicitud, aprobadores } })
				const fn1 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				fn0(dispatch)
				fn1()
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
			})

		}

	}
}

export function solicitarCancelación() {

	const axios = createAxiosInstance()

	return (dispatch, getState) => {

		const solicitud = getState().solicitudhoteles.get('solicitud')

		const errors = validateSolicitud(solicitud)

		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			})
		} else {

			const modificaciones = []

			modificaciones.push({
				id: solicitud.get('id'),
				entity: 'Solicitude',
				value: { motivo_cancelacion: solicitud.get('motivo_cancelacion') },
				action: 'edit'
			})

			axios.put(`${API_URL}/solicitudes/hoteles/${solicitud.get('id')}`, modificaciones)
			.then(res => {
				const solicitud = res.data.solicitud
				const aprobadores = res.data.aprobadores
				const fn0 = (d) => d({ type: types.ACTUALIZAR_SOLICITUD_HOTELES, payload: { solicitud, aprobadores } })
				const fn1 = () => toast.success('Los cambios han sido guardados exitosamente', { bodyClassName: 'toastify-content toastify-success' })
				fn0(dispatch)
				fn1()
			})
			.catch(err => {
				console.log(err)
				displayMessages(dispatch, err)
			})

		}

	}

}


export function enviarComentario() {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud_id = getState().solicitudhoteles.getIn(['solicitud', 'id'])
		const usuario_id = getState().common.getIn(['user', 'id'])
		const id = getState().solicitudhoteles.getIn(['comentario','id'])
		const comentario = getState().solicitudhoteles.getIn(['comentario','texto'])
        const modificaciones = []

		if (id == null) {

			modificaciones.push({
				entity: 'Foro',
				action: 'add',
				id: null,
				value: {
					solicitud_id,
					usuario_id,
					comentario
				}
			})

		} else {

			modificaciones.push({
				id,
				entity: 'Foro',
				value: { comentario },
				action: 'edit'
			})
		}

		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1, payload: true })
		const fn2 = (d) => d({ type: types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_HOTELES1, payload: false })

		fn1(dispatch)
		axios.put(`${API_URL}/solicitudes/hoteles/${solicitud_id}`, modificaciones)
		.then(res => {
			const foros = res.data.solicitud.foros
			const fn3 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1, payload: { foros } })
			fn3(dispatch)
			fn2(dispatch)
		})
		.catch(err => {
			displayMessages(dispatch, err)
			fn2(dispatch)
		})
	}
}

export function editarComentario( id ) {
	return (dispatch) => {
		const fn1 = (d) => d({ type: types.EDITAR_COMENTARIO_SOLICITUD_HOTELES1, payload: { id } })
		fn1(dispatch)
	}
}

export function eliminarComentario(id) {
    const axios = createAxiosInstance()
	return (dispatch, getState) => {
        const solicitud = getState().solicitudhoteles.getIn(['solicitud', 'id'])
        const modificaciones = []
		modificaciones.push({ entity: 'Foro', id, action: 'delete', value: null})
        axios.put(`${API_URL}/solicitudes/hoteles/${solicitud}`, modificaciones)
        .then(res => {
			const foros = res.data.solicitud.foros
			const fn1 = (d) => d({ type: types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_HOTELES1, payload: { foros } })
            fn1(dispatch)
			displayMessages(dispatch, { success: 'La eliminacion han sido realizada exitosamente' })
        })
        .catch(err => {
            displayMessages(dispatch, err)
        })
	}
}

///******* Shared ********///


const validateSolicitud = (data, extra=null) => {
	const errors = []
	if (extra && extra.cancelar && !data.get('motivo_cancelacion')) errors.push('El campo motivo cancelación es obligatorio')
	//const cantpagado = data.getIn(['hotel', 'huespedes']).filter(x => x.getIn(['reservacion', 'valor_pagado']) > 0).count()
	// if (cantpagado > 0) errors.push('No es posible cancelar la solicitud con reservaciones pagadas')
	return errors
}


const validateCotizacion = (data) => {
	const errors = []
	if (!data.get('descripcion')) errors.push('El campo proveedor alojamiento es obligatorio')
	if (!data.get('cotizado') || data.get('cotizado') <= 0) errors.push('El campo valor cotizado es obligatorio')
	if (!data.getIn(['adjunto', 'file'])) errors.push('El campo pantallazo cotización es obligatorio')
	return errors
}





const validateAprobacion = (data, extra) => {
	const errors = []
	if (extra == 2 && data.filter(x => x.get('estado') == 2).count() == 0) errors.push('Debe seleccionar una cotización para aprobar')
	if (extra == 2 && data.filter(x => x.get('estado') == 2).count() > 1) errors.push('Sólo xdbe seleccionar una cotización para aprobar')
	if (extra == 0 && !data) errors.push('El campo observaciones es obligatorio si va a rechazar las cotizaciones')



	return errors
}




const validateReservacion = (data) => {

	const errors = []

	if (!data.getIn(['reservacion', 'proveedor_alojamiento'])) errors.push('El campo proveedor alojamiento es obligatorio')
	if (!data.getIn(['reservacion', 'numero_reservacion'])) errors.push('El campo número reservacion es obligatorio')
	if (!data.getIn(['reservacion', 'fecha_compra'])) errors.push('El campo fecha de compra es obligatorio')
	if (!data.getIn(['reservacion', 'valor_pagado'])) errors.push('El campo valor es obligatorio')
	if (!data.getIn(['reservacion', 'adjunto', 'file'])) errors.push('El campo reservacion es obligatorio')

	const tipo_trayecto = data.getIn(['hotel', 'tipo_trayecto'])

	data.getIn(['reservacion', 'rutas']).map(i => {

		if (i.get('fecha_salida').split(" ")[0] == "") errors.push('El campo fecha salida es obligatorio')
		if (i.get('fecha_salida').split(" ")[1] == "") errors.push('El campo hora salida es obligatorio')

		if (tipo_trayecto == 1) {
			if (i.get('fecha_llegada').split(" ")[0] == "") errors.push('El campo fecha llegada es obligatorio')
			if (i.get('fecha_llegada').split(" ")[1] == "") errors.push('El campo hora llegada es obligatorio')
		}

	})


	if (data.getIn(['reservacion', 'fecha_compra']) && moment(data.getIn(['reservacion', 'fecha_compra'])) > moment(new Date()))
		errors.push('La fecha de compra debe ser menor o igual a la fecha actual')

	return errors
}



const validateAsistencia = (data) => {

	const errors = []
	if (!data.getIn(['asistencia', 'numero_voucher'])) errors.push('El campo número voucher es obligatorio')
	if (!data.getIn(['asistencia', 'fecha_compra'])) errors.push('El campo fecha de compra es obligatorio')
	if (!data.getIn(['asistencia', 'valor'])) errors.push('El campo valor es obligatorio')


	if (!data.getIn(['asistencia', 'adjunto', 'id']) && !data.getIn(['asistencia', 'adjunto', 'file']))
		errors.push('El campo voucher es obligatorio')


	if (data.getIn(['asistencia', 'fecha_compra']) && moment(data.getIn(['asistencia', 'fecha_compra'])) > moment(new Date()))
		errors.push('La fecha de compra debe ser menor o igual a la fecha actual')

	return errors
}


const validateReservaciones = (data) => {
	const errors = []
	data.map((p,i) => {
		if (validateReservacion(p).length > 0) {
			errors.push(`Faltan datos en huesped No. ${i+1}`)
		}
	})


	return errors
}






const validateReservacionesExpirados = (data) => {
	const errors = []
	data.map(t => {
		if (t.get('cumplido') == null) errors.push(`El campo cumplido es obligatorio en el reservacion No. ${t.get('numero_reservacion')}`)
		if ((t.get('cumplido') == 0) && (!t.get('observaciones'))) errors.push(`El campo observaciones es obligatorio en el reservacion No. ${t.get('numero_reservacion')}`)
	})
	return errors
}


const switchDocumento = (change, modificacion) => {

	const path = [...modificacion.attribute]

	modificacion.attribute = path[0]


	if (modificacion.attribute === 'responsable_compras') {
		modificacion.action = 'hidden'
	}

	switch (change.get('op')) {

		case 'add':

			if (modificacion.attribute === 'cotizaciones') {
				modificacion.action = 'create'
			}

			if (modificacion.attribute === 'adjunto') {
				modificacion.action = 'hidden'
			}

			if (modificacion.attribute === 'foros') {
				modificacion.action = 'create'
			}

			break

		case 'remove':
			if (modificacion.attribute === 'cotizaciones') {
				modificacion.action = 'detach'
			}
			break
	}
}


export function crearAprobacionAdicional(aprobador, motivo) {
	const axios = createAxiosInstance();
	return (dispatch, getState) => {
		const errors = validarSolicitudAprobacionAdicional(aprobador, motivo);
		if (errors.length > 0) {
			errors.forEach(x => {
				toast.warning(x, { bodyClassName: 'toastify-content toastify-warning' })
			});
			return;
		}
		const solicitud = getState().solicitudhoteles.get('solicitud')
		const cotizaciones = solicitud.get('cotizaciones');
		const modificaciones = [];
		if (cotizaciones && cotizaciones.size > 0) {
			cotizaciones.forEach(cotizacion => {
				modificaciones.push({
					id: null,
					entity: 'Aprobacione',
					action: 'add',
					value: {
						cotizacion_id: cotizacion.get('id'),
						aprobador_id: aprobador.id,
						estado: 1, // Pendiente de aprobación
						observaciones: motivo,
						tipo: 3
					}
				});
			});
		}
		axios.put(`${API_URL}/solicitudes/hoteles/${solicitud.get('id')}`, modificaciones)
		.then(res => {
			const solicitud = res.data.solicitud;
			const aprobadores = res.data.aprobadores;
			dispatch({ type: types.OBTENER_SOLICITUD_HOTELES, payload: { solicitud, aprobadores } });
			toast.success('Solicitud de aprobación adicional enviada correctamente', { bodyClassName: 'toastify-content toastify-success' });
		})
		.catch(err => {
			displayMessages(dispatch, err);
		});
	}
}


export const validarSolicitudAprobacionAdicional = (aprobador, motivo) => {
	const errors = [];
	if (!aprobador || !aprobador.id) errors.push('Debe seleccionar un aprobador adicional');
	if (!motivo || !motivo.trim()) errors.push('El motivo de la solicitud adicional es obligatorio');
	return errors;
}

























// WEBPACK FOOTER //
// ./src/actions/solicitudhoteles.js